export const GETTING_STARTED_LOCALSTORAGE_KEY =
  'reimbursements-getting-started-visibility'
